module.exports = __webpack_public_path__ + "img/winterhat.7581c055.gif";